export default __webpack_public_path__ + "static/media/icon_views-rectangle.b8500eea.svg";